import React,{useEffect} from "react";
import TourDetails from "../pages/TourDetails";

// Import Hero Image
import manaliHero from "../assets/manali.png";

// Import Gallery Images
import g1 from "../assets/manali.png";
import g2 from "../assets/Manali/SolangValley.png";
import g3 from "../assets/Manali/RohtangPass.png";
import g4 from "../assets/Manali/AtalTunnel.png";
import g5 from "../assets/Manali/Sissu.png";
import g6 from "../assets/Manali/Kullu.png";
import g7 from "../assets/Manali/Naggar.png";
export default function ManaliTour() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <TourDetails
      title="Manali Tour Package"
      duration="06 Nights / 07 Days"
      includes="Manali, Solang Valley, Rohtang Pass, Atal Tunnel, Sissu, Kullu, Naggar"

      heroImage={manaliHero}

      galleryImages={[g1, g2, g3,g4,g5,g6,g7]}

      tourPlan={{
        inclusions: [
          "06 Nights Stay – Hotel Manali Heaven or Similar",
          "Daily Breakfast & Dinner",
          "Private Cab for Complete Sightseeing",
          "Pickup & Drop – Chandigarh/Delhi",
          "All Applicable Taxes Included"
        ],

        days: [
          {
            title: "Day 01: Chandigarh/Delhi → Manali",
            points: [
              "Pickup from Chandigarh/Delhi",
              "Drive to Manali via Sundernagar, Pandoh Dam & Kullu Valley",
              "Check-in at hotel",
              "Dinner & Overnight stay"
            ],
          },

          {
            title: "Day 02: Manali Local Sightseeing",
            points: [
              "Visit Hadimba Devi Temple",
              "Explore Van Vihar",
              "Vashisht Hot Springs",
              "Tibetan Monastery",
              "Evening at Mall Road",
              "Overnight stay at hotel"
            ],
          },

          {
            title: "Day 03: Solang Valley Adventure Day",
            points: [
              "Drive to Solang Valley",
              "Adventure activities: Paragliding, Zorbing, ATV Ride, Skiing (seasonal)",
              "Visit Snow Point (subject to weather)",
              "Return to hotel & overnight stay"
            ],
          },

          {
            title: "Day 04: Atal Tunnel – Sissu Sightseeing",
            points: [
              "Drive to Atal Tunnel (World's Longest Highway Tunnel)",
              "Visit Sissu Waterfall & Sissu Lake",
              "Enjoy snow activities (seasonal)",
              "Return to Manali for night stay"
            ],
          },

          {
            title: "Day 05: Naggar Castle – Jana Waterfall",
            points: [
              "Visit Naggar Castle",
              "Explore Roerich Art Gallery",
              "Visit Jana Waterfall (short trek option)",
              "Return to Manali",
              "Overnight stay"
            ],
          },

          {
            title: "Day 06: Kullu – Manikaran Sightseeing",
            points: [
              "Drive to Kullu",
              "Visit Kullu Shawl Factory",
              "River Rafting (optional)",
              "Visit Manikaran Gurudwara & Hot Springs",
              "Return to Manali & Overnight stay"
            ],
          },

          {
            title: "Day 07: Manali → Chandigarh/Delhi (Departure)",
            points: [
              "Checkout from hotel",
              "Drive back to Chandigarh/Delhi",
              "Drop at Airport / Railway Station",
              "Tour Ends with Beautiful Memories"
            ],
          },
        ],
      }}
    />
  );
}
